{
  "title": "Faerie Fire",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Each object in a 20-foot cube within range is outlined in blue, green, or violet light (your choice).",
    "Any creature in the area when the spell is cast is also outlined in light if it fails a Dexterity saving throw. For the duration, objects and affected creatures shed dim light in a 10-foot radius.",
    "Any attack roll against an affected creature or object has advantage if the attacker can see it, and the affected creature or object can’t benefit from being invisible."
  ],
  "spellLists": ["artificer", "bard", "druid"]
}
